import Box from '@mui/material/Box';
import { FormCheckBox, useTrackedFormik } from '@omnigenbiodata/ui';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { StepProps } from '../../../../core/types/common.types';
import EnrolmentStepContainer from '../EnrolmentStepContainer';

function Consent2Step({ currentStep, onStepForward, onStepBack, values }: StepProps) {
  const { t } = useTranslation('portal');

  const validationSchema = yup.object().shape({
    consent2: yup
      .boolean()
      .required(t('forms.consent2.msg.required') as string)
      .oneOf([true], t('forms.consent2.msg.required') as string),
  });

  const formik = useTrackedFormik(
    {
      initialValues: { consent2: false, ...values },
      validationSchema,
      onSubmit: (values: any) => {
        onStepForward(values);
      },
    },
    'consent2',
  );

  return (
    <EnrolmentStepContainer
      onSubmit={formik.handleSubmit}
      title={t('enrol.consent2.title')}
      text={t('enrol.consent2.text') as string}
      onBack={onStepBack}
      showBack={currentStep > 0}
    >
      <Box mb={4} px={{ xs: 3, sm: 0 }}>
        <FormCheckBox
          error={formik.errors.consent2}
          name="consent2"
          label={t('forms.consent2.label')}
          onChange={formik.handleChange}
          touched={formik.touched.consent2}
          value={formik.values.consent2}
        />
      </Box>
    </EnrolmentStepContainer>
  );
}

export default Consent2Step;
